import { TEntityOverride } from 'src/types'

const override: TEntityOverride = {
  titleField: 'id',
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
    },
  },
  create: {
    properties: {
      markerId: {
        reference: {
          target: 'Marker',
        },
      },
    },
  },
  edit: {
    properties: {
      markerId: {
        reference: {
          target: 'Marker',
        },
      },
    },
  },
}

export default override
